import { gql } from '@apollo/client';

export const FETCH_SURVEY_RESPONSE_QUESTIONS = gql`
  query surveysResponsesQuestions($surveyId: Int, $schoolIds: [Int]) {
    surveysResponsesQuestions(surveyId: $surveyId, schoolIds: $schoolIds) {
      captions {
        key
        label
        color
      }
      schools {
        id
        name
      }
      data {
        uniqueId
        question
        date
        measure
        responses
        answers {
          key
          answer {
            color
            label
            value
            percentage
          }
        }
      }
    }
  }
`;

export const FETCH_SURVEY_RESPONSE_CATEGORIES = gql`
  query surveysResponsesCategories($surveyId: Int, $schoolIds: [Int]) {
    surveysResponsesCategories(surveyId: $surveyId, schoolIds: $schoolIds) {
      captions {
        key
        label
        color
      }
      schools {
        id
        name
      }
      data {
        key
        responses
        questions
        measure
        answers {
          key
          answer {
            color
            label
            value
            percentage
          }
        }
      }
    }
  }
`;

export const FETCH_SURVEYS = gql`
  query listAllSurveys {
    surveysByUser {
      id
      name
      startDate
      endDate
    }
  }
`;

export const QUERY_SURVEY_DASHBOARD_PAGE = gql`
  query surveyDashboardPage {
    surveyDashboardPage {
      data {
        attributes {
          schoolsFilter {
            allSchools
            schoolsSelected
          }
          tabs {
            surveyResponses
            responseTable
          }
          tableQuestion {
            day
            date
            questions
            responses
            answers
          }
          tableCategories {
            questionCategory
            responses
            questions
            answers
          }
          tableResponses {
            category
            date
            question
            total
          }
          toggle {
            questions
            categories
          }
          downloadButton {
            text
          }
          notFoundMessage
        }
      }
    }
  }
`;
